import { render, staticRenderFns } from "./HeaderCartButton.vue?vue&type=template&id=746d5e3c&"
import script from "./HeaderCartButton.vue?vue&type=script&lang=js&"
export * from "./HeaderCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ICart: require('/opt/build/repo/components/svg/Cart.vue').default})
